import animationFrame from './animationFrame';
import loadCss from './loadCss';
import loadJs from './loadJs';
import loadImage from './loadImage';
import trim from './trim';
import isMobile from './isMobile';
import isIpad from './isIpad';
import isIphone from './isIphone';
import isInGame from './isInGame';
import isMobileGame from './isMobileGame';
import wheelDirection from './wheelDirection';
import uniqueId from './uniqueId';
import vendorPrefix from './vendorPrefix';
import getBrowser from './getBrowser';
import getGame from './getGame';
import getNetwork from './getNetwork';
import getOs from './getOs';
import getParam from './getParam';
import getStaticPath from './getStaticPath';
import getUserData from './getUserData';
import getAttr from './getAttr';
import getDevice from './getDevice';
import screenfull from './screenfull';

export default {
  animationFrame,
  getBrowser,
  getDevice,
  getGame,
  getNetwork,
  getOs,
  getParam,
  getStaticPath,
  getUserData,
  getAttr,
  isMobile,
  isMobileGame,
  isIpad,
  isIphone,
  isInGame,
  loadCss,
  loadImage,
  loadJs,
  trim,
  uniqueId,
  vendorPrefix,
  wheelDirection,
  screenfull
};
